/**
 * Created by abbeymart on 2016-12-26.
 */
import type { RouteRecordRaw } from 'vue-router';

export const supportRoutes: Array<RouteRecordRaw> = [
  {
    path: '/support',
    name: 'support',
    redirect: '/support/list',
    component: () => import('pages/central/support/McSupport.vue'),
    meta: {
      title: 'Support Services - Incident Management',
    },
    children: [
      {
        path: 'list',
        name: 'supportList',
        component: () => import('pages/central/support/SupportList.vue'),
        meta: {
          title: 'Supports List',
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'supportDetail',
        component: () => import('pages/central/support/SupportDetail.vue'),
        meta: {
          title: 'Support Detail',
        },
      },
      {
        path: 'new',
        name: 'supportNew',
        component: () => import('pages/central/support/SupportNew.vue'),
        meta: {
          title: 'New Support',
        },
      },
    ],
  },
];
